import React, { Component } from 'react';
import EventsRawTable from '../Components/EventsRawTable/EventsRawTable';
import {useSelector} from 'react-redux';
import {globals} from '../Components/Globals/Globals';

const DiaryView = () => { 
  const {eventsItems} = useSelector((state) => state.events)

  return (
    <div className='view-container'>
      <div>
          <div className='media-container'>
              <h4>Agenda</h4>
              {/** EventsRawTable */}
              <EventsRawTable
                event_list={eventsItems}
                read_only={true}
                />
                
          </div>
      </div>
    </div>
  );
}

export default DiaryView;
